import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargesRequest from "./chargesRequest";
import NotificationPreferencesRequest from "./notificationPreferencesRequest";
import PaymentType from "./paymentType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeOrderRequest {
  /**
   * Customer's email address for payment confirmations and payment instructions.
   */
  @observable
  emailAddress!: string;

  @observable
  @Type(() => NotificationPreferencesRequest)
  notificationPreferences?: NotificationPreferencesRequest;

  @observable
  paymentType!: PaymentType;

  /**
   * External partner ID from whom was the charge purchase proposed.
   */
  @observable
  proposedPurchaseRequestId?: string;

  /**
   * The list of charges.
   */
  @observable
  @Type(() => ChargesRequest)
  charges!: ChargesRequest[];
}
